export default __webpack_public_path__ + "static/media/map-pin-red-blue.a065eb25.svg";